/* Recitem panier V1 — extension du tiroir Lorenza, sans remplacer theme.js. */
(() => {
  'use strict';
  if (window.rcCartBooted) return;
  window.rcCartBooted = true;
  let writing = false;
  const initRoot = root => {
    if (!root || root.dataset.rcReady) return;
    root.dataset.rcReady = 'true';
    const view = root.querySelector('[data-rc-view]');
    const status = root.querySelector('[data-rc-status]');
    const count = root.querySelector('[data-rc-count]');
    let busy = false, timer, generation = 0, controller;
    const isPage = root.dataset.rcPage === 'true';
    const isOpen = () => isPage || root.classList.contains('is-visible');
    const announce = message => { status.textContent = message; };
    const lock = locked => {
      root.setAttribute('aria-busy', String(locked));
      view.querySelectorAll('button').forEach(button => { button.disabled = locked; });
    };
    const applyCount = () => {
      const content = view.querySelector('[data-rc-content]');
      if (content) count.textContent = content.dataset.count;
    };
    const render = async () => {
      const ticket = ++generation;
      if (controller) controller.abort();
      controller = new AbortController();
      const url = new URL(root.dataset.cartUrl, location.origin);
      url.searchParams.set('section_id', root.dataset.sectionId || 'rc-cart-content');
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Impossible de rafraîchir le panier.');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-rc-content]');
      if (!next) throw new Error('Le contenu du panier est indisponible.');
      if (ticket !== generation) return;
      const scroll = view.querySelector('.rc-cart-scroll')?.scrollTop || 0;
      const active = document.activeElement;
      const focusKey = view.contains(active) ? active.dataset.rcKey : null;
      const focusQuantity = view.contains(active) ? active.dataset.rcQuantity : null;
      view.replaceChildren(next);
      const scroller = view.querySelector('.rc-cart-scroll');
      if (scroller) scroller.scrollTop = scroll;
      applyCount();
      // Retrouver la commande après remplacement ; sinon la croix reste accessible.
      if (focusKey) {
        const candidates = Array.from(view.querySelectorAll('[data-rc-key]'));
        const replacement = candidates.find(b => b.dataset.rcKey === focusKey && b.dataset.rcQuantity === focusQuantity)
          || candidates.find(b => b.dataset.rcKey === focusKey);
        (replacement || root.querySelector('.js-close, [data-rc-heading]'))?.focus({ preventScroll: true });
      }
      if (busy) lock(true);
    };
    const reportRefreshError = error => {
      if (error.name === 'AbortError') return;
      announce(isPage ? 'Affichage non actualisé. Rechargez la page pour réessayer.' : 'Affichage non actualisé. Fermez puis rouvrez le panier pour réessayer.');
      // Éviter une modification basée sur une ancienne quantité après une erreur réseau.
      lock(true);
    };
    const schedule = () => {
      if (!isOpen() || busy) return;
      clearTimeout(timer);
      timer = setTimeout(() => render().then(() => { lock(false); announce(''); }).catch(reportRefreshError), 100);
    };
    root.addEventListener('click', async event => {
      const continueLink = event.target.closest('[data-rc-continue]');
      if (continueLink && root.contains(continueLink)) {
        const close = root.querySelector('.js-close');
        if (close) { event.preventDefault(); close.click(); }
        return;
      }
      const shippingArrow = event.target.closest('[data-rc-shipping-direction]');
      if (shippingArrow && root.contains(shippingArrow)) {
        const track = shippingArrow.parentElement.querySelector('.rc-cart-shipping-badges');
        track.scrollBy({ left: Number(shippingArrow.dataset.rcShippingDirection) * track.clientWidth, behavior: 'smooth' });
        return;
      }
      const button = event.target.closest('[data-rc-key], [data-rc-add]');
      if (!button || !root.contains(button)) return;
      event.preventDefault();
      if (busy || writing) return;
      const adding = Boolean(button.dataset.rcAdd);
      const quantity = Number(button.dataset.rcQuantity);
      if (!adding && (!Number.isInteger(quantity) || quantity < 0)) return;
      busy = true; writing = true;
      clearTimeout(timer);
      ++generation;
      if (controller) controller.abort();
      lock(true);
      announce('Mise à jour du panier…');
      let success = false;
      try {
        const payload = adding
          ? { id: button.dataset.rcAdd, quantity: Number(button.dataset.rcAddQuantity || 1) }
          : { id: button.dataset.rcKey, quantity };
        const response = await fetch((adding ? root.dataset.addUrl : root.dataset.changeUrl) + '.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : 'Cette quantité n’est pas disponible.');
        success = true;
        if (adding) document.dispatchEvent(new CustomEvent('flu:cart:item-added', { detail: { product: data } }));
        // Point d’entrée réellement présent dans le theme.js fourni : synchronise
        // le compteur, l’état natif et son événement flu:cart:updated.
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        await render();
        announce(adding ? 'Article ajouté au panier.' : 'Panier mis à jour.');
      } catch (error) {
        // Aucune répétition automatique d’une écriture : une réponse perdue ne
        // doit pas provoquer un double ajout. Relire l’état réel du serveur.
        try { await render(); }
        catch (_) { reportRefreshError(error); return; }
        announce(success ? 'Le panier a été modifié. Vérifiez son contenu.' : (error.message || 'Veuillez vérifier votre panier avant de réessayer.'));
      } finally {
        busy = false; writing = false;
        document.dispatchEvent(new CustomEvent('rc:cart:changed', { detail: { source: root } }));
        // Un échec de rendu conserve les commandes bloquées jusqu’au prochain rafraîchissement réussi.
        if (!status.textContent.startsWith('Affichage non actualisé')) lock(false);
      }
    });
    new MutationObserver(schedule).observe(root, { attributes: true, attributeFilter: ['class'] });
    const nativeItems = root.querySelector('.js-items');
    if (nativeItems) new MutationObserver(schedule).observe(nativeItems, { childList: true });
    document.addEventListener('rc:cart:changed', event => { if (event.detail.source !== root) schedule(); });
    document.addEventListener('flu:cart:updated', schedule);
    document.addEventListener('flu:quick-cart:open', schedule);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
    applyCount();
  };
  const init = () => document.querySelectorAll('[data-rc-cart]').forEach(initRoot);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
